import './InternalPage.css';
import { useLocation, useParams, Link } from 'react-router-dom';
import SideMenu from './SideMenu';
import "./ResearchGroupInfo.css";
import { infrastructure } from './groups';
import InfrastructureInfo from './InfrastructureInfo';
import './InfrastructurePage.css';

export default function InfrastructurePage(props) {

    const location = useLocation();
    const param = new URLSearchParams(location.search);
    const lang = param.get("lang") === "en" ? "en" : "hu";

    const { selectedMenu="" } = useParams();

    const validMenu = infrastructure.find(d => d.path === selectedMenu);

    return (
        <div id="infrastructure-home" className="page-main">
            <SideMenu menuItems={infrastructure} selectedMenuItem={selectedMenu} pathPrefix="/infrastructure/" lang={lang} />
            <div className="content-panel">
                <div >
                    {validMenu && <InfrastructureInfo file={validMenu.file[lang]} lang={lang} />}
                    {!validMenu && <>
                        <h1>{lang==="hu" ? "Kiemelt laboratóriumok" : "Featured laboratories"}</h1>
                        <div className="lab-container">
                            {infrastructure.map((cl, cix) => <InfrastructureBox lab={cl} key={cix} lang={lang} />)}
                        </div>
                    </>}
                </div>
            </div>            
        </div>        
    );
}

function InfrastructureBox(props) {
    const location = useLocation();

    return <Link to={`/infrastructure/${props.lab.path}${location.search}`} className="lab-box-text">
        <div className="lab-box">            
            <div className="lab-box-cover">
                {props.lab.cover && <img src={props.lab.cover} alt="cover"/>}
            </div>
            <div className="lab-box-text">{props.lab[props.lang]}</div>
        </div>
        </Link>;
}